// This method gets the current value for the session token, xsesschk
ht.getSessionToken = function () {
  var tokenVal = ht.xsesschk;
  if (tokenVal == undefined || tokenVal == 'undefined' || tokenVal == '') {
    tokenVal = ht.parseUrlQuery(window.location.href).xsesschk;
  }
  tokenVal = tokenVal || '';
  return tokenVal.replace(/[^a-z0-9_]/gim, '');
};
